<template>
    <layout-basic>
        <v-container>
            <div class="absolute">
                <img class="partner-squircle" src="static/grey-circle.svg">
            </div>
            <section class="container-new banner-text relative">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <div class="about-heading">
                            <h1 class="font-sora">The Only SME Online Training Platform <br>Designed For HR Consultancies</h1>
                            <p class="fs-22">As a partner, we’re here to work with you. Team up with Improve to provide a flexible and<br/> cost-effective training and development solution to your clients, to meet the needs of their <br/>businesses. Treat us as an extension of your team and Improve as the training extension to <br/>your client offer.</p>
                        </div>
                    </v-col>
                </v-row>
            </section>
            <section class="container-small improve-section relative">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <p class="fs-18">Some of our partners</p>
                        <div class="partners-list">
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/Guardian-bussiness-services.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/RSM.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/East-midlands-chamber.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/quest.jpg" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/mywork.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/Digital-HR.png" />
                            </div>
                            <div class="single-partner" v-show="false">
                                <img class="" src="/static/company-logos/Smart-recruit.png" />
                            </div>
                            <div class="single-partner" v-show="false">
                                <img class="" src="/static/company-logos/Black-country-chamber-of-commerce.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/The-HR-Specialists.png" />
                            </div>
                            <div class="single-partner" v-show="false">
                                <img class="" src="/static/company-logos/People-matters-HR.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/trade-association.jpg" />
                            </div>
                            <div class="single-partner" v-show="false">
                                <img class="" src="/static/company-logos/VFD.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/HR-Central.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/engagement-multiplier.jpg" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/hr.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/cornerstone.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/harmonious-hr.png" />
                            </div>
                            <div class="single-partner">
                                <img class="" src="/static/company-logos/induction-junction.png" />
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </section>
            <section class="container-new">
                <v-row>
                    <v-col cols="12" md="12">
                        <div class="about-heading">
                            <h1 class="font-sora">Why Become a Partner?</h1>
                            <p class="fs-18">Provide a flexible and cost-effective training and development solution to your existing portfolio of services, and SME clients.</p>
                            <p class="fs-18">As an official partner, you’ll be part of an exclusive online partner hub where you’ll benefit from marketing support.</p>
                            <p class="fs-18">You’re in control of your client relationships – manage training programmes for them or provide them with a referral link.</p>
                            <p class="fs-18">Improve can be branded with your logo as well as be integrated with other HR systems.</p>
                            <p class="fs-18">Add your own courses, newsletters and training materials.</p>
                            <p class="fs-18">Take advantage of accredited distance learning courses (ILM).</p>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="12">
                        <div class="about-heading">
                            <h1 class="font-sora">Please contact us at any time. We'd be delighted to hear from you.</h1>
                            <p class="mt-4"><img class="mr-2" src="static/icons/envelope.png"><a class="fs-22" href="mailto:hello@improve.online">hello@improve.online</a></p>
                            <p><img class="mr-2" src="static/icons/phone.png"><a class="fs-22" href="tel:01156786278">0115 6786278</a></p>
                            <p>IMPROVE PRODUCTIONS LIMITED <br>Sterling House<br> Wheatcroft Business Park<br> Edwalton<br> Nottingham NG12 4DG</p>
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12">
                        <div class="text-center pt-50">
                            <p class="fs-22 black--text fw-600">Packed with over £1,000 worth of content per person providing great value to your clients</p>
                        </div>
                        <div class="partner-pricing-list">
                            <v-row align="center" justify="center">
                                <v-col cols="12" sm="3" md="3">
                                    <div class="price-item text-center">
                                        <p class="fs-22 fw-600">1-20 USERS</p>
                                        <h1 class="font-sora red-color">£495</h1>
                                        <p class="fs-22 fw-600 per-month">per annum,</p>
                                        <p class="fs-22 fw-600 per-month">per business</p>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <div class="price-item text-center">
                                        <p class="fs-22 fw-600">21-50 USERS</p>
                                        <h1 class="font-sora red-color">£895</h1>
                                        <p class="fs-22 fw-600 per-month">per annum,</p>
                                        <p class="fs-22 fw-600 per-month">per business</p>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <div class="price-item text-center">
                                        <p class="fs-22 fw-600">51-100 USERS</p>
                                        <h1 class="font-sora red-color">£1395</h1>
                                        <p class="fs-22 fw-600 per-month">per annum,</p>
                                        <p class="fs-22 fw-600 per-month">per business</p>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <div class="price-item text-center">
                                        <p class="fs-22 fw-600">101-250 USERS</p>
                                        <h1 class="font-sora red-color">£2695</h1>
                                        <p class="fs-22 fw-600 per-month">per annum,</p>
                                        <p class="fs-22 fw-600 per-month">per business</p>
                                    </div>
                                </v-col>
                                <!--<v-col cols="12" sm="3" md="3" style="max-width:20%;">
                                    <div class="price-item text-center">
                                        <p class="fs-22 fw-600">251-500 USERS</p>
                                        <h1 class="font-sora red-color">£333</h1>
                                        <p class="fs-22 fw-600 per-month">per month,</p>
                                        <p class="fs-22 fw-600 per-month">per business*</p>
                                    </div>
                                </v-col>-->
                            </v-row>
                            <!--<v-row align="center" justify="center">
                                <v-col cols="12" sm="3" md="3" style="max-width:20%;">
                                    <div class="text-center">
                                        <p class="pricing-points" style="font-size:18px;">*Billed Annually</p>
                                    </div>
                                </v-col>
                            </v-row>-->
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <div class="pbt-60">
                            <p class="fs-24 black--text font-sora">Our simple pricing includes</p>
                            <p class="fs-18 mb-0">Access to all courses, all system features and all new courses</p>
                            <p class="fs-18 mb-0">Unlimited upload of training materials, videos files, PDF’s to personalise your courses</p>
                            <p class="fs-18 mb-0">Create and launch unlimited courses of your own</p>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" class="how-hub-different">
                        <div class="">
                            <h1 class="font-sora">How is Partner Hub different?</h1>
                            <p class="fs-18">A dedicated Improve team will work with you, supporting set up and ongoing advice.</p>
                            <p class="fs-18">You can add an unlimited number of clients to the hub.</p>
                            <p class="fs-18">With automated reporting you can see usage information, helping you to identify additional services/customer services opportunities.</p>
                            <p class="fs-18">Partner Hub is full of engaging content that would be worth over £1,000 per user. You can provide this to your SME client from just £40 per month or £400 per year (teams of up to 20).</p>
                            <h3>Benefits for your SME clients:</h3>
                            <h3>We’ve designed courses with SMEs in mind.</h3>
                            <p class="fs-18">Over 50 courses.</p>
                            <p class="fs-18">Get peace of mind on compliance.</p>
                            <p class="fs-18">Induct, develop and retain your people.</p>
                            <p class="fs-18">Simple and practical to apply in the workplace.</p>
                            <p class="fs-18">Designed by a team of L&D and SME professionals so we know what you need.</p>
                            <h3>Improve is here to make life easier.</h3>
                            <p class="fs-18">Create your own company learning Playlist.</p>
                            <p class="fs-18">Easy, automated reporting to keep teams compliant and on track.</p>
                            <p class="fs-18">One system accessed by everyone, on any device, from anywhere.</p>
                            <p class="fs-18">Option to upload your own training materials.</p>
                            <h3>See for yourself. Why not start a free trial today?</h3>
                            <p class="fs-18">Free 14 day trial with no obligation or credit card details needed.</p>
                            <p class="fs-18">Prices start from just £40 per month or £400 per year (teams of up to 20).</p>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6" class="no-image-mobile">
                        <div class="absolute">
                            <img class="partner-squircle2" src="static/grey-circle.svg">
                        </div>
                        <div class="relative">
                            <img class="w-100" src="/static/pages/partner-program/laptop.png" />
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <div class="pt-50">
                            <p class="fs-24 black--text font-sora">What our Partners say about Improve:</p>
                        </div>
                    </v-col>
                </v-row>
            </section>
        </v-container>
        <section class="testi-slider">
            <v-row align="center" justify="center">
                <v-col cols="12" md="11" lg="9" xl="7">
                    <VueSlickCarousel v-bind="testiSliderSettings">
                        <div class="testi-slider-content">
                            <v-row align="center" justify="center">
                                <v-col cols="12" md="12">
                                    <div class="testi-content">
                                        <h2 class="font-sora">"As a digital learning broker it is imperative that I can offer the right solutions to the clients who are seeking my support. I am delighted to partner with IMPROVE. Their learning library is relevant, engaging, flexible and very affordable. With new content being added regularly and an accompanying learning platform which is slick and straightforward it makes an ideal choice for customer looking to offer a broad ranges of topics, across their business in a way that helps them to manage their budget whilst encouraging learning."</h2>
                                        <p class="testi-designation fs-18">Induction Junction</p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="testi-slider-content">
                            <v-row align="center" justify="center">
                                <v-col cols="12" md="12">
                                    <div class="testi-content">
                                        <h2 class="font-sora">"IMPROVE is not only a cost-effective addition to our overall offering but also adds tremendous value for our customers. We believe there are two significant, initial benefits for our customers by using IMPROVE online: saving time, and therefore money, by centralising any training and delivering it fully online to either individuals or groups of employees AND increased engagement and retention of their team members by delivering excellent content in a timely way."</h2>
                                        <p class="testi-designation fs-18">Cornerstone</p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </VueSlickCarousel>
                </v-col>
            </v-row>
        </section>
        <v-container>
            <section class="container-new">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" class="text-center">
                        <div class="about-heading">
                            <h2 class="font-sora">Need More Information?</h2>
                            <p class="fs-22">Our dedicated team are happy to help. Contact them today to arrange your free demo of Partner Hub.</p>
                            <v-btn href="/contact" color="secondary" class="try_free">Contact Us</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </section>
        </v-container>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
    export default {
        name: "PartnerProgramme",
        metaInfo() {
            return {
                title: "Partner with IMPROVE: Flexible Online Training Platform for HR Consultancies",
                meta: [
                    { name: 'description', content: "Partner with IMPROVE, the UK's leading online training platform. Provide SMEs with cost-effective training, branded solutions, and ongoing support while expanding your HR services." },
                    { name: 'keywords', content: "IMPROVE Partner Programme, HR consultancies, SME training solutions, branded LMS, cost-effective training, partner hub, HR system integration, online training for SMEs" },
                    { property: 'og:title', content: "Partner with IMPROVE: Flexible Online Training Platform for HR Consultancies" },
                    { property: 'og:description', content: "Join the IMPROVE Partner Programme to deliver tailored, cost-effective training solutions for SMEs. Branded platforms, HR integrations, and dedicated support for HR consultancies." },
                    { property: 'og:image', content: "https://www.improve.online/static/seo.png" },
                    { property: 'og:type', content: "website" },
                    { property: 'og:url', content: "https://www.improve.online/partner-programme" },
                    { name: 'twitter:card', content: "summary_large_image" },
                    { name: 'twitter:title', content: "Partner with IMPROVE: Flexible Online Training Platform for HR Consultancies" },
                    { name: 'twitter:description', content: "Partner with IMPROVE to offer SMEs flexible and branded training solutions. Explore the Partner Hub, HR integrations, and cost-effective learning options for your clients." },
                    { name: 'twitter:image', content: "https://www.improve.online/static/seo.png" }
                ],
                link: [
                    { rel: 'canonical', href: "https://www.improve.online/partner-programme" }
                ]
            };
        },
        components: {
            LayoutBasic,
            VueSlickCarousel
        },
        data: () => ({
            testiSliderSettings: {
                "arrows": false,
                "dots": true,
                "infinite": true,
                "speed": 500,
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "adaptiveHeight": true
            }
        })
    };
</script>
